(function() {
  
  async function checkCartForTierPoint() {
    try {
      const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await cartRes.json();
      
      if (!cart || !cart.items || cart.items.length === 0) {
        return;
      }

      const hasTierPoint = cart.items.some(item => 
        item.product_title && item.product_title.includes('Tier Point')
      );

      if (hasTierPoint) {
        console.warn("Tier Point item detected");
        await fetch("/cart/clear.js", { method: "POST" })
          .catch(err => console.error("Cart clear error:", err));
        
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.hasAttribute('open')) {
          cartDrawer.close();
        }
        
        const emptyCart = { item_count: 0, items: [] };
        
        if (window.theme && window.theme.pubsub && window.theme.pubsub.PUB_SUB_EVENTS) {
          window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { 
            source: 'tier-point-watcher', 
            cart: emptyCart 
          });
        }
        
        document.dispatchEvent(new CustomEvent('cart:update', { 
          detail: { cart: emptyCart }
        }));
      }
    } catch (err) {
      console.error("Tier Point cart check error:", err);
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    checkCartForTierPoint();
  });

  window.addEventListener('cart:update', checkCartForTierPoint);
  document.addEventListener('cart:loaded', checkCartForTierPoint);
})();